import React, { useEffect, useState } from "react";
import { useFormContext, Controller } from "react-hook-form";
import ModalBox from "../modals/ModalBox";
import NoData from "../../Pages/Relationship/DetailsContent/NoData";
import PopupSelect from "./PopupSelect";

function PopupSelectOther({
  name,
  label,
  rules,
  options = [],
  className,
  onOpen,
  onClose,
  hasData = true,
  selectFunction,
  onConfirm,
  selectedOptionObj,
  createBtn,
  info,
  dialogClassName=''
}) {
  const {
    control,
    setValue,
    trigger,
    watch,
    formState: { errors, isSubmitted },
  } = useFormContext();
  const [showModal, setShowModal] = useState(false);
  const [showOtherField, setShowOtherField] = useState(false);
  const [selectedValue, setSelectedValue] = useState('');
  const [selectedOption, setSelectedOption] = useState({});
  const [selectedOptionType, setSelectedOptionType] = useState('');

  const openModal = () => {
    setSelectedValue("");
    setShowOtherField(false);
    setShowModal(true);
    onOpen && onOpen();
  };

  const handleSelect = (option) => {
    console.log('handleSelect',option);
    if(option.type==="selectrelation"){
      setShowOtherField(true);
    }else{
      setShowOtherField(false);
    }
    setSelectedValue(option.id);
    setSelectedOptionType('main');
    selectFunction && selectFunction(option);
  };

  const handleConfirm = () => {
    const selectedopt = options.find((opt) => opt.id === selectedValue);
    console.log("selectedopt", selectedopt);
    setSelectedOption(selectedopt);
    if(onConfirm){
      onConfirm(selectedopt);
    }else{
      setValue(name, selectedValue);
    }
    setShowModal(false);
    
  };

  useEffect(() => {
    if (isSubmitted) {
      trigger(name);
    }
  }, [watch(name)]);

  useEffect(() => {
    if (selectedOptionObj) {
      setSelectedValue(selectedOptionObj.id);
      setSelectedOption(selectedOptionObj);
      setShowOtherField(selectedOptionObj.optionType==="other");
      setSelectedOptionType(selectedOptionObj.optionType);
    }
  }, [selectedOptionObj]);

  // console.log(options);
  const otherField = {
    name: "responsible_party_other",
    label: "Select Relationship",
    className: "col-12 mb-3",
    dialogClassName:dialogClassName,
    // rules: { required: "Please enter city" },
    type: "popupselect",
    fieldType: "form",
    selectedOptionObj: selectedOptionObj,
    // selectFunction: (opt) => {
    //   console.log(opt);
    // },
    onConfirm: (option) => {
      // console.log(option);
      const selectedopt = options.find((opt) => opt.id === option.id);
      setSelectedValue(selectedopt.id);
      setSelectedOptionType('other');
      // setSelectedOption(selectedopt);
      // setResponsiblePartyOther(opt);
    },
    isShow: watch("show_responsible_party_other") === "1",
  };

  return (
    <div className={className}>
      <label htmlFor={name} className="form-label  me-2">
        {label}
      </label>
      {info}
      <Controller
        name={name}
        control={control}
        defaultValue=""
        rules={rules}
        render={({ field }) => (
          <div className="row">
            <div onClick={() => openModal()}>
              <input className="form-control" value={watch(name)} readOnly />
              {/* <pre>{JSON.stringify(selectedOption, null, 2)}</pre> */}
              {/* <pre>{JSON.stringify(selectedOptionObj, null, 2)}</pre> */}
              
            </div>
            <ModalBox
              isShow={showModal}
              handleClose={() => {
                onClose && onClose();
                setShowModal(false);
              }}
              modalSize="md"
              hasData={hasData}
              dialogClassName={dialogClassName}
            >
              <div className="text-center position-relative">
                <h3 className="modal-title mb-3 mt-0">{label}</h3>
              </div>
              <div className="row">
                {options?.length > 0 ? (
                  (() => {
                    const filteredOptions = options?.filter(
                      (option) => option.optionType === "main"
                    );

                    return filteredOptions.length > 0 ? (
                      filteredOptions.map((option, index) => (
                        <>
                          <div key={index} className="col-12 mb-3">
                            <div
                              className="row"
                              onClick={() => handleSelect(option)}
                            >
                              <div className="col-11">
                                <label
                                  className="form-check-label ms-1"
                                  htmlFor={name + `-radio-` + option.id}
                                >
                                  <div className="d-flex align-items-center justify-content-center justify-content-md-start flex-wrap text-center ">
                                    <div className="mt-2 mt-md-0 ms-lg-1 text-lg-start rltnshp-txt">
                                      <p className="mb-1">
                                        {option.name}
                                      </p>
                                    </div>
                                  </div>
                                </label>
                              </div>
                              <div className="col-1 d-flex align-items-center">
                                <div className="form-check form-checked">
                                  <input
                                    name={name}
                                    type="radio"
                                    value={option.id}
                                    className="form-check-input"
                                    id={name + `-radio-` + option.id}
                                    // onChange={() => handleSelect(option)}
                                    checked={(selectedOptionType==="main" && selectedValue == option.id) || (selectedOptionType==="other" && option.id==="other")}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          {option.type === "selectrelation" && showOtherField && (
                            <PopupSelect
                              options={options?.filter((opt) => opt.optionType === "other")}
                              {...otherField}
                            />
                          )}
                        </>
                      ))
                    ) : (
                      <NoData />
                    );
                  })()
                ) : (
                  <NoData />
                )}
                {createBtn && (
                  <div className="col-12 mb-3">
                    <div className="row" onClick={() => {
                      createBtn.onClick();
                      setShowModal(false);
                    }}>
                      <div className="col-11">
                        <div className="d-flex align-items-center justify-content-center justify-content-md-start flex-wrap text-center ">
                          <span className="material-symbols-outlined create-icon me-2">
                            {createBtn.icon}
                          </span>
                          <div className="mt-2 mt-md-0 ms-lg-1 text-lg-start rltnshp-txt">
                            <p className="mb-1">{createBtn.name}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="row">
                <div className="col-12">
                  <button
                    type="button"
                    className="btn btn-primary rounded-pill w-100 my-2 p-2"
                    onClick={handleConfirm}
                    disabled={!selectedValue || selectedValue=='other'}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </ModalBox>
          </div>
        )}
      />

      {errors[name] && <span className="error">{errors[name].message}</span>}
    </div>
  );
}

export default PopupSelectOther;
